import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { FeaturedListings } from '../main-page/components/featured-listings';
import { LISTING_ROUTES } from '../main-page/home-utils';
import "../../hs-theme.css";
import "../main-page/main-page.css";
import "./listing-not-found.css";

const Hexagon = (props) => (
    <svg viewBox="0 0 40 44" fill="none" {...props}><path d="M20 1.5 38 11.75v20.5L20 42.5 2 32.25v-20.5Z" fill="#0073F0" /></svg>
);

export const ListingNotFound = ({ className = '' }) => {
    const { t } = useTranslation(["common"]);

    return (
        <div className={`hs hs-nf ${className}`}>
            <section className='hs-nf-section'>
                <div className='hs-nf-card'>
                    <Hexagon className='hs-nf-deco right' />
                    <Hexagon className='hs-nf-deco left' />
                    <div className='hs-nf-icon'>
                        <span className='hs-nf-icon-back'></span>
                        <span className='hs-nf-icon-front'></span>
                        <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#0073F0" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9v11h14V9" /><path d="m10 12.5 4 4M14 12.5l-4 4" /></svg>
                        <span className='hs-nf-icon-alert'>!</span>
                    </div>
                    <span className='hs-nf-badge'><span className='dot'></span>{t('not_found_eyebrow')}</span>
                    <h1 className='hs-nf-title'>{t('listing_not_found')}</h1>
                    <p className='hs-nf-text'>{t('not_found_text')}</p>
                    <div className='hs-nf-buttons'>
                        <Link to={LISTING_ROUTES[0]} className='hs-nf-primary' onClick={() => sessionStorage.removeItem('currentPage')}>
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                            {t('not_found_search')}
                        </Link>
                        <Link to='/' className='hs-nf-secondary'>{t('not_found_home')}</Link>
                    </div>
                </div>
            </section>

            <FeaturedListings eyebrow={t('similar_eyebrow')} title={t('similar_title')} />
        </div>
    );
};
